import { useMutation } from "@tanstack/react-query";
import { cancelSession } from "services/Session.services";

import { queryClient } from "utils/queryClient";

export function useDeleteSessionDialog() {
  const deleteSessionMutation = useMutation<void, Error, string>({
    mutationFn: (sessionId) => cancelSession(sessionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sessions"] });
    },
  });

  return { deleteSessionMutation };
}
